/* Listens for a customer answering a pour-conditions warning and makes sure a
   dispatcher cannot miss a DELAY. Mounted on the dispatch-side boards. */
import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { WS_BASE } from "@/lib/api";
import { tone } from "@/lib/voice";

const ALERT = { delay: "warning", call_me: "warning", go_ahead: "ok" };

export default function WeatherReplyWatcher() {
  const seen = useRef(new Set());

  useEffect(() => {
    let closed = false;
    let ws = null;
    let retry = 0;
    let timer = null;

    const announce = (evt) => {
      const key = `${evt.job_id}:${evt.code}:${evt.ts}`;
      if (seen.current.has(key)) return;
      seen.current.add(key);
      const who = evt.customer_name || "A customer";
      if (evt.code === "delay") {
        tone(880, 0.18, 0, 0.5); tone(660, 0.26, 0.2, 0.5);
        toast.error(`${who} asked to DELAY the pour`, { description: "They want a call to rebook — the order is flagged on the board.", duration: 15000 });
      } else if (evt.code === "call_me") {
        tone(760, 0.2, 0, 0.45);
        toast.warning(`${who} asked for a CALL BACK`, { description: "They want to talk the conditions through before you deliver.", duration: 12000 });
      } else {
        toast.success(`${who} confirmed GO AHEAD`, { description: "Deliver as planned.", duration: 7000 });
      }
    };

    const connect = () => {
      if (closed) return;
      try { ws = new WebSocket(`${WS_BASE}/ws/dispatch`); } catch { return; }
      ws.onmessage = (e) => {
        try {
          const evt = JSON.parse(e.data);
          if (evt.type === "job.weather_reply" && ALERT[evt.code]) announce(evt);
        } catch { /* ignore */ }
      };
      ws.onopen = () => { retry = 0; };
      ws.onclose = () => {
        if (closed) return;
        retry += 1;
        timer = setTimeout(connect, Math.min(15000, 1000 * 2 ** Math.min(retry, 4)));
      };
      ws.onerror = () => { try { ws.close(); } catch { /* ignore */ } };
    };
    connect();
    return () => { closed = true; clearTimeout(timer); try { ws && ws.close(); } catch { /* ignore */ } };
  }, []);

  return null;
}
